// import '@/static/fonts/icons.css'

export const options = {
  rtl: true,
  theme: {
    dark: false, // From 2.0 You have to select the theme dark or light here
    themes: {
      light: {
        primary: '#ff7100', // a color that is not in the material colors palette - class="primary--text"
        secondary: '#2e2824',
        secondary2: '#363636',
        tertiary: '#3e4a54',
        lightBlack: '#231f20'
      }
    }
  },

  options: {
    minifyTheme: function(css) {
      return process.env.NODE_ENV === 'production'
        ? css.replace(/[\s|\r\n|\r|\n]/g, '')
        : css;
    }
  }
};

export default function getVuetifyOptions() {
  return options;
}
